<template>
    <span class="flex-container toggle" :class="{'toggled': checked}">
        <input
            type="checkbox"
            :checked="checked"
            @change="$emit('change', $event.target.checked)"
        >
        <slot></slot>
    </span>
</template>

<script>
export default {
    model: {
        prop: 'checked',
        event: 'change',
    },
    props: {
        checked: Boolean,
    },
};
</script>

<style lang="scss" scoped>
input {
    display: none;
}
span {
    display: inline-block;
    position: relative;
    width: 35px;
    height: 22px;
    border: 1px solid #e4e4e4;
    border-radius: 60px;
    user-select: none;
    transition: 0.4s ease;
    margin: 0 0 0 5px;
    cursor: pointer;
    flex-shrink: 0;
    &::before {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        border-radius: 30px;
        transition: 0.2s cubic-bezier(0.24, 0, 0.5, 1);
    }
    &::after {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 20px;
        height: 20px;
        border-radius: 60px;
        background: whitesmoke;
        box-shadow: 0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 0 0 hsla(0, 0%, 0%, 0.04), 0 4px 9px hsla(0, 0%, 0%, 0.13), 0 3px 3px hsla(0, 0%, 0%, 0.05);
        transition: 0.35s cubic-bezier(0.54, 1.60, 0.5, 1);
    }
}
.toggled {
    &::before {
        background: #2ecc71;
        transition: width 0.2s cubic-bezier(0, 0, 0, 0.1);
    }
    &::after {
        left: 13px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/utils/BmrToggle.vue